export const VALIDATION = {
  FILL_ALL: 'Please fill the area.',
  INVALID: 'Invalid Format',
  SOMETHING_WRONG: 'SOMETHING WENT WRONG',
};

export const SERVICES = [
  { key: 'ip', label: 'IP ADDRESS' },
  { key: 'location', label: 'LOCATION' },
  { key: 'timezone', label: 'TIMEZONE' },
  { key: 'isp', label: 'ISP' },
];
